import { render, staticRenderFns } from "./DeviceNotAllowed.vue?vue&type=template&id=f300ff04"
import script from "./DeviceNotAllowed.vue?vue&type=script&lang=js"
export * from "./DeviceNotAllowed.vue?vue&type=script&lang=js"
import style0 from "./DeviceNotAllowed.vue?vue&type=style&index=0&id=f300ff04&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports